/**
 * Schema of AuditoriaMotivo
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import AuditoriaMotivo from '@/model/resource/AuditoriaMotivo'

export default (model: AuditoriaMotivo): Schema => ({
  idMotivoPk: {
    content: model.idMotivoPk,
    editable: false,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
